import { Card, CardContent } from '@/components/ui/card';
import { Building2, Award, Users, TrendingUp } from 'lucide-react';

export const AboutSection = () => {
  const stats = [
    {
      icon: Award,
      value: "15+",
      label: "Années d'expertise",
      description: "dans le poids lourd"
    },
    {
      icon: TrendingUp,
      value: "500+",
      label: "Véhicules vendus",
      description: "clients satisfaits"
    },
    {
      icon: Users,
      value: "100%",
      label: "Accompagnement",
      description: "personnalisé"
    }
  ];

  return (
    <section className="py-16 bg-white" id="about">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Texte à gauche */}
          <div>
            <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 rounded-lg mb-4">
              <Building2 className="h-6 w-6 text-blue-600" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Trucks 52 SARL : Votre Expert en Véhicules Industriels d'Occasion
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Située à <strong>Val-de-Meuse en Haute-Marne (52)</strong>, Trucks 52 SARL est votre partenaire de confiance 
                pour l'achat et la vente de <strong>véhicules industriels d'occasion</strong>. Depuis plus de 15 ans, 
                nous mettons notre expertise au service des professionnels du transport et de la logistique dans le 
                <strong> Grand Est</strong> et partout en France.
              </p>
              <p>
                Sous la direction de <strong>Laurent DESNOUVEAUX</strong>, notre équipe sélectionne rigoureusement 
                chaque véhicule : <strong>camions porteurs, tracteurs routiers, semi-remorques</strong> et 
                <strong> utilitaires</strong>. Nous garantissons des véhicules conformes aux normes environnementales 
                <strong> Euro 5 et Euro 6</strong>, avec une attention particulière aux 
                <strong> vignettes Crit'Air</strong> pour circuler librement dans les zones à faibles émissions.
              </p>
              <p>
                Notre atelier certifié assure l'<strong>entretien et la révision complète</strong> de chaque véhicule 
                avant la mise en vente. Nous proposons également des solutions de <strong>financement adaptées</strong>, 
                la <strong>reprise de votre ancien véhicule</strong>, et un service de <strong>livraison partout en France</strong>.
              </p>
              <p className="font-semibold text-blue-900">
                Chez Trucks 52 SARL, nous ne vendons pas seulement des véhicules, nous construisons des partenariats 
                durables basés sur la confiance, la transparence et la qualité.
              </p>
            </div>
          </div>

          {/* Statistiques à droite */}
          <div className="space-y-6">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <Card key={index} className="border-2 border-blue-100 hover:border-blue-300 transition-all hover:shadow-lg">
                  <CardContent className="p-6">
                    <div className="flex items-center space-x-4">
                      <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
                        <Icon className="h-8 w-8 text-white" />
                      </div>
                      <div className="flex-1">
                        <div className="text-3xl font-bold text-blue-600 mb-1">{stat.value}</div>
                        <div className="font-semibold text-gray-900">{stat.label}</div>
                        <div className="text-sm text-gray-600">{stat.description}</div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              );
            })}

            {/* Coordonnées de contact */}
            <Card className="bg-gradient-to-br from-blue-600 to-blue-700 border-0 text-white">
              <CardContent className="p-6">
                <h3 className="text-xl font-bold mb-4">Contactez-nous</h3>
                <div className="space-y-3 text-blue-50">
                  <p className="font-semibold">Laurent DESNOUVEAUX</p>
                  <p>📞 06 08 24 85 29</p>
                  <p>✉️ trucks.52@orange.fr</p>
                  <p className="text-sm">
                    📍 2 Place de l'Église<br />
                    52140 Val-de-Meuse, Haute-Marne<br />
                    Région Grand Est
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};